import React, { ChangeEvent, FormEvent, useState } from 'react'

import { Input, Text, ButtonHTMLLink } from 'components'
import { urls } from 'screens/Organization/urls'
import { appProtocol, appDomain, appPath, superDomain } from 'config'
import { useShowPublicOrganizationQuery } from 'remote/graphql'
import { FormattedMessage, useIntl } from 'react-intl'
import { isAskXDesktop } from '../../../utils'
import { setItemSafe } from '../../../helpers/localStorage'

const isDomainValid = (domain: string) => domain.length > 3

export function SelectByDomain({ superEnabled }: { superEnabled: boolean }) {
  const intl = useIntl()
  const [domain, setDomain] = useState('')
  const productDomain = superEnabled ? superDomain : appDomain

  const {
    data,
    loading,
    error: apolloError,
  } = useShowPublicOrganizationQuery({
    variables: { domain },
    skip: !isDomainValid(domain),
  })

  const allowLogin =
    !loading &&
    !apolloError &&
    isDomainValid(domain) &&
    data?.showPublicOrganization?.domain === domain

  const domainError =
    !loading &&
    !apolloError &&
    isDomainValid(domain) &&
    !data?.showPublicOrganization

  const onDomainChange = (event: ChangeEvent<HTMLInputElement>) => {
    const domain = event.target.value
    setDomain(domain.toLowerCase())
  }

  const onSubmit = (event: FormEvent) => {
    event.preventDefault()
    if (allowLogin) {
      window.location.href = urls.getOrganizationAppPath(
        { appDomain: productDomain, appProtocol, appPath },
        domain
      )
    }
  }

  return (
    <>
      <Text.Section className="margin-bottom-12">
        <FormattedMessage
          id="boarding.organization.select.byDomain.title"
          defaultMessage="Use your team URL"
          values={{}}
        />
      </Text.Section>
      <form onSubmit={onSubmit} className="width-full">
        <div className="flexbox">
          <Input
            id="domain"
            placeholder={intl.formatMessage({
              id: 'boarding.organization.select.byDomain.placeholder',
              defaultMessage: 'subdomain',
            })}
            className="width-full radius-large"
            value={domain}
            onChange={onDomainChange}
            renderRight={({ className }) => (
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
              <div className={className}>.{productDomain}</div>
            )}
          />
          {allowLogin && (
            <ButtonHTMLLink
              variant="primary"
              className="margin-left-12 radius-large"
              href={urls.getOrganizationAppPath(
                { appDomain: productDomain, appProtocol, appPath },
                domain
              )}
              onClick={() => {
                if (isAskXDesktop()) {
                  setItemSafe('askxsubdomain', domain)
                }
              }}
              // eslint-disable-next-line formatjs/no-literal-string-in-jsx
            >
              →
            </ButtonHTMLLink>
          )}
        </div>
        <div className="yellow">
          {domainError &&
            intl.formatMessage({
              id: 'boarding.organization.select.byDomain.error',
              defaultMessage: 'We could not find your team',
            })}
          &nbsp;
        </div>
        {apolloError && (
          <div className="yellow">
            <FormattedMessage
              id="boarding.organization.select.byDomain.apolloError"
              defaultMessage="A network error occurred while looking for your team"
            />
          </div>
        )}
      </form>
    </>
  )
}
